import React, { useState } from "react";
import {
  Box,
  Flex,
  Text,
  VStack,
  Image,
  Avatar,
  Collapse,
} from "@chakra-ui/react";
import { useLocation, useNavigate } from "react-router-dom";
import { adminRoutes } from "../../../common/constants";
import { IoIosArrowDown, IoIosArrowUp } from "react-icons/io";
import { useGetUser } from "../../../../services/query/account";

const SideBar = () => {
  const { pathname } = useLocation();
  const navigate = useNavigate();
  const [showMenu, setShowMenu] = useState(false);
  const [currentIndex, setCurrentIndex] = useState("");
  const isSubItemActive = (subRoute) => {
    return pathname.startsWith(subRoute);
  };
  const isParentActive = (path) => pathname.startsWith(path);
  const { data } = useGetUser();

  return (
    <Flex
      flexDir="column"
      justifyContent="space-between"
      position={"fixed"}
      zIndex={800}
      w="256px"
      bg="#FAFAFA"
    >
      <Box h="100vh" overflowY="scroll">
        <Flex
          bg="#FAFAFA"
          pos="sticky"
          zIndex={55}
          pt="25px"
          top="0"
          justifyContent="center"
        >
          <Image
            src="/assets/logo.png"
            w="219px"
            h="52px"
            objectFit="contain"
          />
        </Flex>

        <Box pl="18px" w="full" mt="39px" mb="65px">
          <Flex
            boxShadow="0px 4px 4px 0px #00000040"
            borderRadius="8px"
            bg="#F8FAFC"
            p="12px"
            className="parent"
            align="center"
            gap="12px"
          >
            <Avatar w="40px" h="40px" />
            <Box>
              <Text
                color="#0F172A"
                fontSize="14px"
                fontWeight={600}
                lineHeight="160%"
              >
                {data?.data?.name}
              </Text>

              <Text
                color="#64748B"
                fontSize="12px"
                fontWeight={500}
                lineHeight="160%"
              >
                @
                {data?.data?.role === "SuperAdmin"
                  ? "Super Admin"
                  : data?.data?.role}
              </Text>
            </Box>
          </Flex>
        </Box>

        <Box pl="18px" w="full">
          <Box mt="60px">
            {adminRoutes?.map((item, i) => {
              return (
                <VStack
                  key={i}
                  align="stretch"
                  mb="20px"
                  className={!isParentActive(item.path) && "parent_nav"}
                  gap={0}
                >
                  <Flex
                    align="center"
                    p={2}
                    pt={3}
                    cursor="pointer"
                    onClick={() =>
                      item.sub
                        ? (showMenu && currentIndex === item.id
                            ? setShowMenu(false)
                            : !showMenu && setShowMenu(true),
                          setCurrentIndex(item.id))
                        : (navigate(item.path),
                          setShowMenu(false),
                          setCurrentIndex(""))
                    }
                    boxShadow={
                      showMenu
                        ? showMenu && currentIndex === item.id
                          ? `
                      0px 0.75px 3.63px 0px #596C9409, 
                      0px 6px 12px 0px #596C941A
                    `
                          : ""
                        : isParentActive(item.path)
                          ? `
                      0px 0.75px 3.63px 0px #596C9409, 
                      0px 6px 12px 0px #596C941A
                    `
                          : ""
                    }
                    borderRadius={
                      showMenu
                        ? showMenu && currentIndex === item.id
                          ? "12px"
                          : "none"
                        : isParentActive(item.path)
                          ? "12px"
                          : "none"
                    }
                    bg={
                      showMenu
                        ? showMenu && currentIndex === item.id
                          ? "#FFFFFF"
                          : "transparent"
                        : isParentActive(item.path)
                          ? "#FFFFFF"
                          : "transparent"
                    }
                    border={
                      showMenu
                        ? showMenu && currentIndex === item.id
                          ? "1px solid #E6E7EC"
                          : "none"
                        : isParentActive(item.path)
                          ? "1px solid #E6E7EC"
                          : "none"
                    }
                    fontWeight={
                      showMenu
                        ? showMenu && currentIndex === item.id
                          ? "700"
                          : "500"
                        : isParentActive(item.path)
                          ? "700"
                          : "500"
                    }
                    color="#0A1B39"
                    _hover={{
                      boxShadow: `
                      0px 0.75px 3.63px 0px #596C9409, 
                      0px 6px 12px 0px #596C941A
                    `,
                      bg: "#fff",
                      border: "1px solid #E6E7EC",
                      borderRadius: "8px",
                    }}
                    h="45px"
                    position="relative"
                    justifyContent="space-between"
                  >
                    <Flex align="center" gap="24px">
                      <Box className="initial_image">{item.icon}</Box>
                      <Box>
                        <Text fontSize="14px">{item.name}</Text>
                      </Box>
                    </Flex>

                    {item?.sub && (
                      <Box
                        textAlign="right"
                        color={
                          showMenu && currentIndex === item.id
                            ? "#fff"
                            : "black"
                        }
                      >
                        {showMenu && currentIndex === item.id ? (
                          <IoIosArrowDown />
                        ) : (
                          <IoIosArrowUp />
                        )}
                      </Box>
                    )}
                  </Flex>

                  {item.sub && (
                    <Collapse in={showMenu && currentIndex === item.id}>
                      <VStack
                        mt="15px"
                        align="stretch"
                        borderBottomRadius={4}
                        pb="2"
                        gap={0}
                      >
                        {item.sub.map((subItem, i) => (
                          <Flex
                            key={i}
                            align="center"
                            borderRadius="12px"
                            h="44px"
                            pl={4}
                            cursor="pointer"
                            onClick={() => navigate(subItem.route)}
                            _hover={{ bg: "#fff" }}
                            style={{
                              textDecoration: "none",
                              color: "#444648",
                              fontWeight: isSubItemActive(subItem.route)
                                ? "700"
                                : "400",
                            }}
                            bg={
                              isSubItemActive(subItem.route)
                                ? "#FFFFFF"
                                : "transparent"
                            }
                            gap="16px"
                          >
                            <Box pos="relative">
                              <Box
                                h="45px"
                                pos="absolute"
                                left="3.5px"
                                top="-18px"
                                w="1px"
                                bg="#D8DBE4"
                              />
                              <Box
                                rounded="full"
                                w="8px"
                                h="8px"
                                pos="relative"
                                zIndex={22}
                                bg={
                                  isSubItemActive(subItem.route)
                                    ? "#012A82"
                                    : "#D8DBE4"
                                }
                              />
                            </Box>
                            <Box
                              fontSize="13px"
                              opacity={0.8}
                              color={
                                isSubItemActive(subItem.route)
                                  ? "#012A82"
                                  : "#0A1B39"
                              }
                              ml="26px"
                              mb={0}
                            >
                              {subItem.label}
                            </Box>
                          </Flex>
                        ))}
                      </VStack>
                    </Collapse>
                  )}
                </VStack>
              );
            })}
          </Box>
        </Box>
      </Box>
    </Flex>
  );
};

export default SideBar;
